import { LoadingButton } from '@mui/lab';
import { DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import React from 'react';

const MakeDefaultApproveModal = ({
  open,
  handleClose,
  isLoading,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>
        آیا از انتخاب این کد به عنوان کد پیش فرض مطمئن هستید ؟
      </DialogTitle>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          color="warning"
          disabled={isLoading}
        >
          انصراف
        </Button>
        <LoadingButton
          variant="contained"
          onClick={() => onConfirm()}
          loading={isLoading}
        >
          تایید
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default MakeDefaultApproveModal;
